import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class LoginNameService{
    loginUserName=new BehaviorSubject<string>('');

    userLoggedIn(name:string){
        this.loginUserName.next(name);
    }

    getObservable(){
        return this.loginUserName.asObservable();
    }
}